import { TopBar } from "@/components/TopBar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { BeliefShiftSection } from "@/components/BeliefShiftSection";
import { VideoSection } from "@/components/VideoSection";
import { ProblemSection } from "@/components/ProblemSection";
import { InterludeSection } from "@/components/InterludeSection";
import { IdentitySection } from "@/components/IdentitySection";
import { ShiftSection } from "@/components/ShiftSection";
import { ModulesSection } from "@/components/ModulesSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { PleasureSection } from "@/components/PleasureSection";
import { DimensionsSection } from "@/components/DimensionsSection";
import { StorySection } from "@/components/StorySection";
import { CurrencySection } from "@/components/CurrencySection";
import { DreamLifeSection } from "@/components/DreamLifeSection";
import { OfferSection } from "@/components/OfferSection";
import { BooksSection } from "@/components/BooksSection";
import { BonusSection } from "@/components/BonusSection";
import { SecondProofSection } from "@/components/SecondProofSection";
import { ForYouSection } from "@/components/ForYouSection";
import { FaqSection } from "@/components/FaqSection";
import { FinalCloseSection } from "@/components/FinalCloseSection";
import { FinalOffer } from "@/components/FinalOffer";
import { Footer } from "@/components/Footer";
import { StickyCta } from "@/components/StickyCta";

export default function SalesPage() {
  return (
    <main data-testid="sales-page" className="pb-24 md:pb-0">
      <TopBar />
      <Hero />
      <Marquee />
      <BeliefShiftSection />
      <VideoSection />
      <ProblemSection />
      <InterludeSection />
      <IdentitySection />
      <ShiftSection />
      <ModulesSection />
      <TestimonialsSection />
      <PleasureSection />
      <DimensionsSection />
      <StorySection />
      <CurrencySection />
      <DreamLifeSection />
      <OfferSection />
      <BooksSection />
      <BonusSection />
      <SecondProofSection />
      <ForYouSection />
      <FaqSection />
      <FinalCloseSection />
      <FinalOffer />
      <Footer />
      <StickyCta />
    </main>
  );
}
